module.exports = __webpack_public_path__ + "static/media/ahp-logo.6340a02e.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/Header/resources/ahp-logo.svg
// module id = 3382
// module chunks = 0